<script setup lang="ts">
import { computed } from 'vue'

import type { MediaRootProps } from '@fondof-ui/components/media/types'

const props = defineProps<MediaRootProps>()

const hasVideo = computed(() => {
  return (
    props.entry?.videoMobile?.url ||
    props.entry?.videoTablet?.url ||
    props.entry?.videoDesktop?.url ||
    props.entry?.videoId
  )
})

const hasImage = computed(() => {
  return (
    props.entry?.imageMobile?.url ||
    props.entry?.imageTablet?.url ||
    props.entry?.imageDesktop?.url
  )
})

const videoData = computed(() => {
  return {
    videoMobile: props.entry?.videoMobile,
    videoTablet: props.entry?.videoTablet,
    videoDesktop: props.entry?.videoDesktop,
    videoId: props.entry?.videoId,
    videoIdType: props.entry?.videoIdType,
    videoAutoplay: props.entry?.videoAutoplay,
    videoMuted: props.entry?.videoMuted,
    videoLoop: props.entry?.videoLoop,
    videoControls: props.entry?.videoControls,
    videoPreload: props.entry?.videoPreload,
    imageMobile: props.entry?.imageMobile,
    imageTablet: props.entry?.imageTablet,
    imageDesktop: props.entry?.imageDesktop,
    specialClass: props.entry?.specialClass,
    lazyload: props.entry?.lazyload,
  }
})

const imageData = computed(() => {
  return {
    imageMobile: props.entry?.imageMobile,
    imageTablet: props.entry?.imageTablet,
    imageDesktop: props.entry?.imageDesktop,
    specialClass: props.entry?.specialClass,
    dividerMobile: props.entry?.dividerMobile,
    dividerTablet: props.entry?.dividerTablet,
    dividerDesktop: props.entry?.dividerDesktop,
    lazyload: props.entry?.lazyload,
  }
})
</script>

<template>
  <div :class="props.class">
    <slot
      v-if="hasVideo"
      name="video"
      :data="videoData"
    />
    <slot
      v-else-if="hasImage"
      name="image"
      :data="imageData"
    />
  </div>
</template>
